import * as React from 'react';

import { Button } from '../Button/Button';
import { Markdown } from '../Markdown/Markdown';
import { routes } from '../../config/routes';

import * as cs from './CaseStudyText.module.css';

interface Props {
  caseStudyPreview: string;
  className?: string;
  slug?: string | null;
  readMoreText: string;
}

export const CaseStudyText = ({
  caseStudyPreview,
  slug,
  className,
  readMoreText,
}: Props) => {
  return (
    <div className={className}>
      <article className={cs.caseStudyText}>
        <Markdown body={caseStudyPreview} data-theme-reset />
      </article>
      {slug && (
        <div>
          <Button
            className={cs.readMore}
            size="lg"
            variant="solid"
            theme="primary"
            to={routes.blogPost(slug)}
          >
            {readMoreText}
          </Button>
        </div>
      )}
    </div>
  );
};
